window.fumiAddToCart = async function fumiAddToCart({ formData, triggerEl } = {}) {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer || !formData) return null;

  if (triggerEl) cartDrawer.setActiveElement?.(triggerEl);
  cartDrawer.openWithLoading(triggerEl || document.activeElement);

  if (cartDrawer.getSectionsToRender) {
    if (!formData.has('sections')) {
      formData.append(
        'sections',
        cartDrawer.getSectionsToRender().map((section) => section.id).join(',')
      );
    }
    if (!formData.has('sections_url')) {
      formData.append('sections_url', window.location.pathname);
    }
  }

  const config =
    typeof fetchConfig === 'function'
      ? fetchConfig('javascript')
      : { method: 'POST', headers: { Accept: 'application/javascript' } };
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  config.body = formData;

  try {
    const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}`, config);
    const data = await response.json();
    if (data.status) {
      cartDrawer.setLoading(false);
      throw new Error(data.description || data.message);
    }

    cartDrawer.classList.remove('is-empty');

    if (cartDrawer.renderContents && data.sections) {
      cartDrawer.renderContents(data);
    } else {
      cartDrawer.setLoading(false);
      document.querySelector('cart-drawer-items')?.refreshCartDrawer?.();
    }

    return data;
  } catch (error) {
    cartDrawer.setLoading(false);
    throw error;
  }
};

(() => {
  if (window.__fumiCartDrawerComplementaryBound) return;
  window.__fumiCartDrawerComplementaryBound = true;

  async function addComplementaryToCart(container) {
    const addBtn = container.querySelector('[data-fumi-cart-complementary-add]');
    const variantId = container.dataset.variantId;
    if (!addBtn || !variantId || addBtn.disabled || container.dataset.fumiCartComplementarySubmitting === 'true') {
      return;
    }

    container.dataset.fumiCartComplementarySubmitting = 'true';
    addBtn.disabled = true;

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    try {
      await window.fumiAddToCart({ formData, triggerEl: addBtn });
    } catch (error) {
      console.error(error);
    } finally {
      delete container.dataset.fumiCartComplementarySubmitting;
      addBtn.disabled = false;
    }
  }

  document.addEventListener('click', (event) => {
    const addBtn = event.target.closest('[data-fumi-cart-complementary-add]');
    if (!addBtn) return;

    event.preventDefault();
    event.stopPropagation();

    const container = addBtn.closest('[data-fumi-cart-complementary-form]');
    if (!container) return;

    addComplementaryToCart(container);
  });
})();

function initFumiCartDrawerComplementary() {
  // Kept for cart.js refresh hook; click handling uses document delegation.
}
